import { Injectable } from "@angular/core";
import { GlobalService } from "app/global/global.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { BankIdClientV6, CollectResponseV6 } from 'app/bankid';
import moment from "moment";
import { TranslocoService } from "@jsverse/transloco";
import { environment } from "environments/environment";

export interface BankIdResponse {
    status: boolean;
    response: CollectResponseV6;
    orderRef?: string
}
@Injectable({
    providedIn: 'root'
})

export class BankIdService {
    constructor(
        private globalService: GlobalService,
        private deviceService: DeviceDetectorService,
        private BankIdClientV6: BankIdClientV6,
        private _translocoService: TranslocoService
    ) { }
    async signWithBankId(orderRef: string): Promise<{ success: boolean, response: CollectResponseV6 }> {
        return new Promise((resolve, reject) => {
            const timer = setInterval(async () => {
                try {
                    const res = await this.BankIdClientV6.collect({ orderRef });

                    if (res.status === 'complete') {
                        clearInterval(timer);
                        resolve({ success: true, response: res });
                    } else if (res.status === 'failed') {
                        clearInterval(timer);
                        reject(new Error(res.hintCode));
                    }
                } catch (err) {
                    clearInterval(timer);
                    reject(err);
                }
            }, 1000);
        });
    }

    /**
   * get the order ref on sign bankid
   * @returns response
   */
    async signBankid(role_id: number, persnol_no: string, name: string, unique_id: string, apiRouteName: string = 'eform-bank-id') {
        this.BankIdClientV6.options = { ...this.BankIdClientV6.options, roleId: role_id, production: false, refreshInterval: 1000, v: 'v6.0', apiRouteName: apiRouteName };
        const requirement = persnol_no ? { requirement: { personalNumber: String(persnol_no).replace(/-/g, "") } } : null;
        const response = await this.BankIdClientV6.sign({
            endUserIp: environment.endUserIp,
            user_visible_data: this.user_visible_data(name, unique_id),
            ...requirement
        });
        return response;
    }

    /**
       * set the user visible data in bankid
       * @returns string
       */
    user_visible_data = (document_name: string, unique_id: string): string => (this._translocoService.translate("Bankid user visiable data message (Signing page - section) - I sign document with id on date", { document: document_name, unique_id: unique_id, date: moment().format('MMMM Do YYYY, h:mm:ss a') }));

    /**
     * cancel bankid request
     * @param orderRef 
     */
    cancel(orderRef: string) {
        this.BankIdClientV6.cancel({ orderRef: orderRef });
    }
}